import { ethers } from 'ethers';

export function shortenAddress(addr) {
  if (!addr) return '';
  return addr.slice(0, 6) + '...' + addr.slice(-4);
}

export function formatUSDT(value) {
  if (!value) return '0.00';
  try {
    const formatted = ethers.utils.formatUnits(value, 18);
    const num = parseFloat(formatted);
    if (num >= 1000000) return (num / 1000000).toFixed(2) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(2) + 'K';
    return num.toFixed(2);
  } catch {
    return '0.00';
  }
}

export function formatUSDTRaw(value) {
  if (!value) return '0.00';
  try {
    return parseFloat(ethers.utils.formatUnits(value, 18)).toFixed(2);
  } catch {
    return '0.00';
  }
}

export function parseUSDT(value) {
  try {
    return ethers.utils.parseUnits(String(value), 18);
  } catch {
    return ethers.BigNumber.from(0);
  }
}

export const PACKAGE_LABELS = ['$1', '$5', '$10', '$25', '$50', '$100', '$200'];
export const PACKAGE_PRICES = [1, 5, 10, 25, 50, 100, 200];
export const PACKAGE_NAMES = ['Starter', 'Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond', 'Crown'];
export const PACKAGE_COLORS = ['#94a3b8', '#cd7f32', '#c0c0c0', '#ffd700', '#e5e4e2', '#b9f2ff', '#ff6b35'];

export const POOL_LABELS = [
  'Starter Daily Share',
  'Bronze Daily Share',
  'Silver Daily Share',
  'Gold Daily Share',
  'Platinum Daily Share',
  'Diamond Daily Share',
];

export function timeAgo(timestamp) {
  if (!timestamp || timestamp === 0) return 'N/A';
  const now = Math.floor(Date.now() / 1000);
  const diff = now - Number(timestamp);
  if (diff < 60) return 'Just now';
  if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
  if (diff < 86400) return Math.floor(diff / 3600) + 'h ago';
  return Math.floor(diff / 86400) + 'd ago';
}

export function formatDate(timestamp) {
  if (!timestamp || timestamp === 0) return 'N/A';
  return new Date(Number(timestamp) * 1000).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric'
  });
}

export function getErrorMessage(error) {
  if (!error) return 'Unknown error';
  if (error.reason) return error.reason;
  if (error.data && error.data.message) return error.data.message;
  if (error.message) {
    if (error.message.includes('user rejected')) return 'Transaction rejected by user';
    if (error.message.includes('insufficient funds')) return 'Insufficient BNB for gas';
    if (error.message.includes('AR')) return 'Already registered';
    if (error.message.includes('NR')) return 'Not registered';
    if (error.message.includes('IA')) return 'Please approve USDT first';
    if (error.message.includes('IB')) return 'Insufficient USDT balance';
    if (error.message.includes('PNA')) return 'Previous package not active';
    if (error.message.includes('PAA')) return 'Package already active';
    if (error.message.includes('IP')) return 'Invalid package';
    if (error.message.includes('NE')) return 'Not eligible for this pool';
    if (error.message.includes('NN')) return 'No new rounds to claim';
    if (error.message.includes('NI')) return 'No income to claim';
    if (error.message.includes('NM')) return 'Eligibility not met';
    return error.message.length > 100 ? error.message.slice(0, 100) + '...' : error.message;
  }
  return 'Transaction failed';
}
